const addCustomEvents = (events) => {
    events.forEach((e) => {
        if (e instanceof Event) {
            // If event exists, just add a listener
            window.addEventListener(e.name, e.callback);
        } else {
            window.addEventListener(e.name, e.callback);

            // Add available events list
            if (!window.availableCustomEvents) {
                window.availableCustomEvents = [];
            }

            // Add event name to available custom events list
            if (window.availableCustomEvents.indexOf(e.name) < 0) {
                window.availableCustomEvents.push(e.name);
            }
        }
    });
};

const dispatchCustomEvent = (name, data) => {
    window.dispatchEvent(
        new CustomEvent(name, {
            detail: data || {}
        })
    );
};

export { addCustomEvents, dispatchCustomEvent };
